import { Component, OnInit } from "@angular/core";
import { UserDto } from "../../core/dto/user.dto";
import { UserProfiles } from "../../core/interfaces/userProfiles";
import { UserService } from "../../core/services/user.service";
import { NavControllerExtended } from "../../gyzmo-commons/helpers/navControllerExtended";

@Component({
    selector: "app-home",
    templateUrl: "./home.page.html",
    styleUrls: ["./home.page.scss"],
})
export class HomePage implements OnInit {
    public user: UserDto;

    UserProfiles = UserProfiles;

    constructor(private navControllerExtended: NavControllerExtended,
                private userService: UserService) {
    }

    async ngOnInit() {
        this.user = await this.userService.getCurrentUserWithThirdPartyOnly();
        if (this.user.profile.id === UserProfiles.PREPARATEUR || this.user.profile.id === UserProfiles.PREPARATEUR_CHAUFFEUR || this.user.profile.id === UserProfiles.VEGA) {
            await this.navControllerExtended.navigateRoot("/home/departure");
        } else if (this.user.profile.id === UserProfiles.CHAUFFEUR) {
            await this.navControllerExtended.navigateRoot("/home/delivery-list");
        }
    }
}
